// Tenant realm resolution from the chart-rendered tenant-realms.json (architecture §4.6).
// Side-effect-free so it can be unit-tested without bootstrapping the app.

export function normalizeTenantValue(value) {
  const normalized = (value || '').trim().toLowerCase();
  return normalized || null;
}

// Raised when a realm hint is requested (or defaulted) that is not in tenant-realms.json.
// §4.6: an unknown realm is an error page, never a silent guess.
export class UnknownRealmError extends Error {
  constructor(realm) {
    super(`Unknown tenant realm: ${realm}`);
    this.name = 'UnknownRealmError';
    this.realm = realm;
  }
}

// Resolve {selectedTenant, selectedRealm} from the authoritative realm list. Throws
// UnknownRealmError if the requested (or default) realm is not present.
export function resolveFromRealmList(realmList, currentUrl) {
  const defaultTenant = normalizeTenantValue((realmList || {}).defaultRealm) || 'zaya';
  const byId = {};
  ((realmList || {}).tenants || []).forEach(t => {
    const id = normalizeTenantValue(t.id);
    if (id) {
      byId[id] = ((t.realm || id).toString().trim()) || id;
    }
  });

  // Prefer `realm`; accept legacy `kc_realm` so existing bookmarks/shared links still resolve.
  const requested = normalizeTenantValue(currentUrl.searchParams.get('realm') || currentUrl.searchParams.get('kc_realm'));
  const selectedTenant = requested || defaultTenant;

  if (requested && !Object.prototype.hasOwnProperty.call(byId, requested)) {
    throw new UnknownRealmError(requested);
  }
  if (!Object.prototype.hasOwnProperty.call(byId, selectedTenant)) {
    throw new UnknownRealmError(selectedTenant);
  }
  return {selectedTenant, selectedRealm: byId[selectedTenant]};
}
